import { put, select } from 'redux-saga/effects';
import { find } from 'lodash';

import makeRequest from 'rdx/utils/makeRequest';
import putErrorActions from 'rdx/utils/putErrorActions';
import { setSearchCytometers } from 'rdx/modules/cytometers/slice';
import { getCurrentOrganization } from 'rdx/modules/organization/slice';
import { getSessionActions } from 'rdx/modules/auth/slice';

function* getSearchCytometers({ payload: { query, onSuccess, onError } }) {
  const sessionActions = yield select(getSessionActions);
  const action = find(sessionActions, { name: 'organization_cytometers' });

  const organization = yield select(getCurrentOrganization);
  const params = { ...query };
  if (!params.organization_id) {
    params.organization_id = organization.attributes.slug;
  }
  const { success, data, error } = yield* makeRequest.action(action, params);
  if (success) {
    if (onSuccess) {
      onSuccess();
    }
    yield put(setSearchCytometers(data));
  } else if (error) {
    if (onError) {
      onError();
    }
    yield* putErrorActions({ error });
  }
  return null;
}

export default getSearchCytometers;
